import React, { FC, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalScale={8}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
});

export default function FormattedInputs({
  value,
  set_value,
  label,
  endAdornment,
  decimalScale,
  intScale,
  fullWidth,
  disabled,
  readOnly,
}) {
  const classes = useStyles();
  const [values, setValues] = React.useState({
    textmask: "(1  )    -    ",
    numberformat: "1320",
  });

  const handleChange = (event) => {
    set_value(event.target.value);
  };

  return (
    <div className={classes.root}>
      <TextField
        label="react-number-format"
        value={value}
        onChange={handleChange}
        name="numberformat"
        id="formatted-numberformat-input"
        InputProps={{
          inputComponent: NumberFormatCustom,
          inputProps: {
            // decimalScale: decimalScale,
            // intScale: intScale,
            // readOnly: readOnly,
          },
          endAdornment: (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ),
        }}

        variant="standard"
      />
    </div>
  );
}
